// Geometri-hjelpere delt av hele SKADE: peiling-projeksjon (samme formel som
// GNÅ-kartet og cot_mapping._project) og GeoJSON-typer for kart-laget.
const EARTH_R = 6_371_000; // meter
/** Projiserer et punkt gitt start, peiling (grader fra nord) og avstand (m). */
export function project(from, bearingDeg, rangeM) {
    const ang = rangeM / EARTH_R;
    const brg = (bearingDeg * Math.PI) / 180;
    const lat1 = (from.lat * Math.PI) / 180;
    const lon1 = (from.lon * Math.PI) / 180;
    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(ang) + Math.cos(lat1) * Math.sin(ang) * Math.cos(brg));
    const lon2 = lon1 +
        Math.atan2(Math.sin(brg) * Math.sin(ang) * Math.cos(lat1), Math.cos(ang) - Math.sin(lat1) * Math.sin(lat2));
    return { lat: (lat2 * 180) / Math.PI, lon: (lon2 * 180) / Math.PI };
}
/** Storsirkel-avstand mellom to punkt (meter). */
export function haversineM(a, b) {
    const dLat = ((b.lat - a.lat) * Math.PI) / 180;
    const dLon = ((b.lon - a.lon) * Math.PI) / 180;
    const lat1 = (a.lat * Math.PI) / 180;
    const lat2 = (b.lat * Math.PI) / 180;
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    return 2 * EARTH_R * Math.asin(Math.min(1, Math.sqrt(h)));
}
/** Sirkel som lukket polygon-ring ([lon,lat]-par), til WEZ/fareavstand-visning. */
export function ringPolygon(center, radiusM, steps = 64) {
    const pts = [];
    for (let i = 0; i <= steps; i++) {
        const p = project(center, (360 * i) / steps, radiusM);
        pts.push([p.lon, p.lat]);
    }
    return pts;
}
/**
 * Sektor (kakestykke) som lukket polygon-ring ([lon,lat]-par) — til peilinger,
 * synsfelt og siktretninger.
 *
 * `bearingDeg` er sektorens MIDTLINJE og `halvbreddeDeg` er utslaget til hver
 * side, så en linse med 70° synsfelt gis `halvbreddeDeg: 35`. Med `rMinM > 0`
 * blir figuren en ringsektor (nær grense klippet bort) i stedet for et kakestykke
 * fra origo.
 *
 * ⚠ BUEN SAMPLES, KORDEN GJØR DET IKKE. En sektor tegnet som tre punkt (origo,
 * venstre kant, høyre kant) ser ut som en trekant, og en trekant UNDERDRIVER
 * arealet: den utelater nettopp den ytre delen av buen der usikkerheten er
 * størst. Operatøren ville da lest et smalere søkeområde enn geometrien tilsier.
 */
export function sektorPolygon(origin, bearingDeg, halvbreddeDeg, rMaxM, rMinM = 0, steps = 48) {
    const halv = Math.max(0, Math.min(180, halvbreddeDeg));
    const fra = bearingDeg - halv;
    const til = bearingDeg + halv;
    const ytre = Math.max(0, rMaxM);
    const indre = Math.max(0, Math.min(rMinM, ytre));
    const n = Math.max(2, Math.floor(steps));
    const pts = [];
    // Ytre bue, venstre → høyre.
    for (let i = 0; i <= n; i++) {
        const b = fra + ((til - fra) * i) / n;
        const p = project(origin, b, ytre);
        pts.push([p.lon, p.lat]);
    }
    if (indre > 0) {
        // Indre bue tilbake, høyre → venstre, så ringen lukkes riktig.
        for (let i = n; i >= 0; i--) {
            const b = fra + ((til - fra) * i) / n;
            const p = project(origin, b, indre);
            pts.push([p.lon, p.lat]);
        }
    }
    else {
        pts.push([origin.lon, origin.lat]); // spissen i origo
    }
    pts.push(pts[0]); // lukk ringen
    return pts;
}
export function featureCollection(features) {
    return { type: 'FeatureCollection', features };
}
//# sourceMappingURL=geo.js.map